export const quizQuestions = [
  {
    id: 'question1',
    text: 'Do you own your domain, hosting, and have access to your cloud provider?',
    risk: "If you don't, you're not in control. You can be locked out, ransomed, or completely paralyzed if the relationship with the agency sours."
  },
  {
    id: 'question2',
    text: 'Do you own all your repositories and API documentation?',
    risk: "Without ownership and documentation, you can't audit the code, fix bugs, or onboard new developers — you're stuck with whoever wrote it."
  },
  {
    id: 'question3',
    text: 'Do you have a plan B to make a fix and deploy to production without the help of your agency?',
    risk: "Things break. If you can't fix and deploy without your agency, your business is at their mercy during emergencies."
  },
  {
    id: 'question4',
    text: 'If your agency disappeared tomorrow, could you keep the product running and continue building?',
    risk: "This reveals your actual level of independence. If the answer is no, you don't own a product — you rent one."
  },
  {
    id: 'question5',
    text: 'Is the person who truly understands how your product works — end to end — on your side?',
    risk: "If no one on your team understands the tech, you're not making informed decisions — you're just following orders and hoping it works."
  },
  {
    id: 'question6',
    text: "Do you have signed CLAs of everyone who's ever written a line of code?",
    risk: "Without legal agreements, you may not actually own your code — and that's a nightmare for fundraising, acquisitions, or legal disputes."
  },
  {
    id: 'question7',
    text: 'Did you know how much your last epic was going to cost before development?',
    risk: "Building without cost clarity leads to budget blowups, scope creep, and wasted money — and it's usually a sign of poor planning or a bad partner."
  }
];

export const getScoreMessage = (score) => {
  if (score === 100) {
    return "Excellent! You're well-prepared for technical leadership.";
  } else if (score >= 71) {
    return "Good foundation, but there are gaps that could cost you.";
  } else if (score >= 43) {
    return "Some technical leadership skills, but significant risks remain.";
  } else {
    return "Critical gaps in technical leadership - immediate attention needed.";
  }
};

export const calculateQuizScore = (answers) => {
  const yesCount = Object.values(answers).filter(answer => answer === true).length;
  return Math.round((yesCount / 7) * 100);
};